import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridDirectTypeFromIdCellRenderer from "@/components/inputs/AGGridDirectTypeFromIdCellRenderer.vue";

export default class AGGridDirectTypeFromIdColumn extends AGGridColumn {
  protected type: string;

  constructor(column: namaTypes.ListScreenColumn, entityType: string, type: string | undefined) {
    super(column, entityType);
    this.type = type ?? "";
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridDirectTypeFromIdCellRenderer;
    colDef.cellRendererParams = {
      metaData: this.column.metaData,
      entityType: this.type
    };
    return colDef;
  }
}
